<template>
  <v-app>
    <div style="background-color: #7B1FA2;">
      <div style="background-color: #7B1FA2;margin:0px;padding: 10px;color:#BB86FC;font-size: 20px;font-weight: bold;text-align: right;">
        SuperSaas Modul, verzia 1.0
      </div>
    </div>
    <v-main style="background-color: #F4F5FA;">
      <SuperSaas v-if="is_verified"/>
    </v-main>
    <v-footer app>
      <v-row>
        <v-col class="text-center">
          <span style="font-size: 11px;"><a href="https://irool.cz" target="_blank" style="color:#E11824;text-decoration:none;">INDEX NOSLUŠ s.r.o.</a> &copy; 2017 <a href="https://irool.cz" target="_blank" style="color:#9D6AFD;text-decoration:none;">RooL - Roland Olejár</a>. Všetky práva vyhradené.</span>
        </v-col>
      </v-row>
    </v-footer>
  </v-app>
</template>

<script>
import Cookies from 'js-cookie'
import SuperSaas from './components/SuperSaas.vue';

export default {
  name: 'App',

  components: {
    SuperSaas,
  },

  data: () => ({
    id_token: null,
    is_verified: false,
  }),

  created() {
    this.id_token = Cookies.get('id_token')

    if (!this.id_token) {

      window.location.href = 'https://login.noslus.cz?service=supersaas'
    } else {

      this.verifyToken()
    }
  },
  methods: {
    verifyToken() {
      fetch('https://supersaas-server.noslus.cz/api/v1/token/verify', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'id-token': this.id_token,
        },
      })
      .then(response => {
        if (!response.ok) {
          throw new Error('Token verification failed')
        }
        return response.json()
      })
      .then(data => {
        console.log('Token verification successful:', data)
        this.is_verified = true
      })
      .catch(error => {
        console.error('Error verifying token:', error)
        this.is_verified = false
        this.redirectToLogin()
      })
    },
    redirectToLogin() {
      window.location.href = 'https://login.noslus.cz?service=supersaas'
    },
  },
}
</script>
